// Generated from MerchantPermission.cs by tools/permissions/generate-permissions.js; run `npm run permissions` instead of editing.
const permissions = Object.freeze({
  MerchantUserDashboardRead: 'MerchantUserDashboardRead',
  MerchantUserDashboardExport: 'MerchantUserDashboardExport',
  MerchantEarningAndBurningDashboardRead: 'MerchantEarningAndBurningDashboardRead',
  MerchantEarningAndBurningDashboardExport: 'MerchantEarningAndBurningDashboardExport',
  MerchantMonthlyUserRewardDashboardRead: 'MerchantMonthlyUserRewardDashboardRead',
  MerchantMonthlyUserRewardDashboardExport: 'MerchantMonthlyUserRewardDashboardExport',
  MerchantUserTransactionDashboardRead: 'MerchantUserTransactionDashboardRead',
  MerchantUserTransactionDashboardExport: 'MerchantUserTransactionDashboardExport',
  MerchantUserRelationRateDashboardRead: 'MerchantUserRelationRateDashboardRead',
  MerchantUserRelationRateDashboardExport: 'MerchantUserRelationRateDashboardExport',
  MerchantUserExchangedGiftDashboardRead: 'MerchantUserExchangedGiftDashboardRead',
  MerchantUserExchangedGiftDashboardExport: 'MerchantUserExchangedGiftDashboardExport',
  MerchantGiftRead: 'MerchantGiftRead',
  MerchantGiftCreate: 'MerchantGiftCreate',
  MerchantGiftUpdate: 'MerchantGiftUpdate',
  MerchantGiftDelete: 'MerchantGiftDelete',
  VoucherRead: 'VoucherRead',
  VoucherImport: 'VoucherImport',
  VoucherSyncToPos: 'VoucherSyncToPos',
  MerchantGiftReportRead: 'MerchantGiftReportRead',
  MerchantGiftReportSendMail: 'MerchantGiftReportSendMail',
  MerchantContentRead: 'MerchantContentRead',
  MerchantContentCreate: 'MerchantContentCreate',
  MerchantContentUpdate: 'MerchantContentUpdate',
  MerchantContentDelete: 'MerchantContentDelete',
  MerchantContentApprove: 'MerchantContentApprove',
  MissionRead: 'MissionRead',
  MissionCreate: 'MissionCreate',
  MissionUpdate: 'MissionUpdate',
  MissionDelete: 'MissionDelete',
  MerchantContentSettingRead: 'MerchantContentSettingRead',
  MerchantContentSettingCreate: 'MerchantContentSettingCreate',
  MerchantContentSettingUpdate: 'MerchantContentSettingUpdate',
  MerchantContentSettingDelete: 'MerchantContentSettingDelete',
  DistributorRead: 'DistributorRead',
  DistributorCreate: 'DistributorCreate',
  DistributorUpdate: 'DistributorUpdate',
  DistributorDelete: 'DistributorDelete',
  MerchantStoreRead: 'MerchantStoreRead',
  MerchantStoreCreate: 'MerchantStoreCreate',
  MerchantStoreUpdate: 'MerchantStoreUpdate',
  MerchantStoreDelete: 'MerchantStoreDelete',
  MerchantStoreReview: 'MerchantStoreReview',
  MerchantStoreImport: 'MerchantStoreImport',
  GiftCardRead: 'GiftCardRead',
  GiftCardCreate: 'GiftCardCreate',
  GiftCardUpdate: 'GiftCardUpdate',
  GiftCardDelete: 'GiftCardDelete',
  TrackingStatusOrderRead: 'TrackingStatusOrderRead',
  TrackingStatusOrderExport: 'TrackingStatusOrderExport',
  MerchantWarehousesRead: 'MerchantWarehousesRead',
  ReceiveInventoryRead: 'ReceiveInventoryRead',
  ReceiveInventoryCreate: 'ReceiveInventoryCreate',
  ReceiveInventoryUpdate: 'ReceiveInventoryUpdate',
  ReceiveInventoryImport: 'ReceiveInventoryImport',
  ReceiveInventoryDelete: 'ReceiveInventoryDelete',
  DeliverInventoryRead: 'DeliverInventoryRead',
  DeliverInventoryCreate: 'DeliverInventoryCreate',
  DeliverInventoryUpdate: 'DeliverInventoryUpdate',
  DeliverInventoryImport: 'DeliverInventoryImport',
  DeliverInventoryDelete: 'DeliverInventoryDelete',
  TransferInventoryRead: 'TransferInventoryRead',
  TransferInventoryCreate: 'TransferInventoryCreate',
  TransferInventoryUpdate: 'TransferInventoryUpdate',
  TransferInventoryImport: 'TransferInventoryImport',
  TransferInventoryDelete: 'TransferInventoryDelete',
  ProductRead: 'ProductRead',
  ProductCreate: 'ProductCreate',
  ProductUpdate: 'ProductUpdate',
  ProductDelete: 'ProductDelete',
  ProductImport: 'ProductImport',
  ProductsGroupRead: 'ProductsGroupRead',
  ProductsGroupCreate: 'ProductsGroupCreate',
  ProductsGroupUpdate: 'ProductsGroupUpdate',
  ProductsGroupDelete: 'ProductsGroupDelete',
  ProductCodeRead: 'ProductCodeRead',
  ProductGenerate: 'ProductGenerate',
  ProductCodeExport: 'ProductCodeExport',
  ProductCodeUsedRead: 'ProductCodeUsedRead',
  ProductCodeUsedExport: 'ProductCodeUsedExport',
  ProductLoyaltyProgramSettingRead: 'ProductLoyaltyProgramSettingRead',
  ProductLoyaltyProgramSettingCreate: 'ProductLoyaltyProgramSettingCreate',
  ProductLoyaltyProgramSettingUpdate: 'ProductLoyaltyProgramSettingUpdate',
  GiftOnDemandRead: 'GiftOnDemandRead',
  GiftOnDemandCreate: 'GiftOnDemandCreate',
  GiftOnDemandUpdate: 'GiftOnDemandUpdate',
  GiftOnDemandDelete: 'GiftOnDemandDelete',
  GiftOnDemandImport: 'GiftOnDemandImport',
  GiftOnDemandExport: 'GiftOnDemandExport',
  GiftCardRecoveryRead: 'GiftCardRecoveryRead',
  GiftCardRecoveryCreate: 'GiftCardRecoveryCreate',
  GiftCardRecoveryUpdate: 'GiftCardRecoveryUpdate',
  GiftCardRecoveryDelete: 'GiftCardRecoveryDelete',
  GiftCardRecoveryExport: 'GiftCardRecoveryExport',
  AdminManagementRead: 'AdminManagementRead',
  AdminManagementCreate: 'AdminManagementCreate',
  AdminManagementUpdate: 'AdminManagementUpdate',
  AdminManagementDelete: 'AdminManagementDelete',
  AdminManagementImport: 'AdminManagementImport',
  AdminUserPermissionManagementRead: 'AdminUserPermissionManagementRead',
  AdminUserPermissionManagementCreate: 'AdminUserPermissionManagementCreate',
  AdminUserPermissionManagementUpdate: 'AdminUserPermissionManagementUpdate',
  AdminUserPermissionManagementDelete: 'AdminUserPermissionManagementDelete',
  UserManagementRead: 'UserManagementRead',
  UserManagementEdit: 'UserManagementEdit',
  UserManagementExport: 'UserManagementExport',
  CustomerDataManagementRead: 'CustomerDataManagementRead',
  CustomerDataManagementCreate: 'CustomerDataManagementCreate',
  CustomerDataManagementUpdate: 'CustomerDataManagementUpdate',
  CustomerDataManagementDelete: 'CustomerDataManagementDelete',
  CustomerFilterManagementRead: 'CustomerFilterManagementRead',
  CustomerFilterManagementCreate: 'CustomerFilterManagementCreate',
  CustomerFilterManagementUpdate: 'CustomerFilterManagementUpdate',
  CustomerFilterManagementImport: 'CustomerFilterManagementImport',
  CustomerFilterManagementDelete: 'CustomerFilterManagementDelete',
  MerchantAccessGroupRead: 'MerchantAccessGroupRead',
  MerchantAccessGroupCreate: 'MerchantAccessGroupCreate',
  MerchantAccessGroupUpdate: 'MerchantAccessGroupUpdate',
  MerchantAccessGroupDelete: 'MerchantAccessGroupDelete',
  MerchantNotificationRead: 'MerchantNotificationRead',
  MerchantNotificationCreate: 'MerchantNotificationCreate',
  MerchantNotificationUpdate: 'MerchantNotificationUpdate',
  MerchantNotificationDelete: 'MerchantNotificationDelete',
  MerchantNotificationReportRead: 'MerchantNotificationReportRead',
  MerchantHandleTicket: 'MerchantHandleTicket',
  MerchantInchargeTicket: 'MerchantInchargeTicket',
  MerchantHandleChat: 'MerchantHandleChat',
  MerchantTicketSettingsRead: 'MerchantTicketSettingsRead',
  MerchantTicketSettingsCreate: 'MerchantTicketSettingsCreate',
  MerchantTicketSettingsUpdate: 'MerchantTicketSettingsUpdate',
  MerchantTicketSettingsDelete: 'MerchantTicketSettingsDelete',
  MerchantTicketListRead: 'MerchantTicketListRead',
  MerchantTicketListCreate: 'MerchantTicketListCreate',
  MerchantTicketListUpdate: 'MerchantTicketListUpdate',
  MerchantTicketListExport: 'MerchantTicketListExport',
  MerchantTransactionPointRead: 'MerchantTransactionPointRead',
  MerchantTransactionPointReview: 'MerchantTransactionPointReview',
  MerchantTransactionGiftRead: 'MerchantTransactionGiftRead',
  MerchantRetailTransactionRead: 'MerchantRetailTransactionRead',
  MerchantRetailTransactionExport: 'MerchantRetailTransactionExport',
  MerchantAnonymousRetailTransactionRead: 'MerchantAnonymousRetailTransactionRead',
  MerchantAnonymousRetailTransactionExport: 'MerchantAnonymousRetailTransactionExport',
  MerchantAnonymousRetailTransactionDownload: 'MerchantAnonymousRetailTransactionDownload',
  ImportUserRead: 'ImportUserRead',
  ImportUserCreate: 'ImportUserCreate',
  ImportTransactionRead: 'ImportTransactionRead',
  ImportTransactionCreate: 'ImportTransactionCreate',
  BillUploadRead: 'BillUploadRead',
  BillUploadReview: 'BillUploadReview',
  DeliveryTransactionRead: 'DeliveryTransactionRead',
  PointManagementRead: 'PointManagementRead',
  PointManagementReview: 'PointManagementReview',
  PointManagementCreate: 'PointManagementCreate',
  PointManagementUpdate: 'PointManagementUpdate',
  PointManagementListRead: 'PointManagementListRead',
  CheckInTransactionRead: 'CheckInTransactionRead',
  IdVerificationListRead: 'IdVerificationListRead',
  MerchantObjectSettingsCDPRead: 'MerchantObjectSettingsCDPRead',
  MerchantObjectSettingsCDPUpdate: 'MerchantObjectSettingsCDPUpdate',
  MerchantObjectSettingsCDPExport: 'MerchantObjectSettingsCDPExport',
  MerchantObjectSettingsLoyaltyRead: 'MerchantObjectSettingsLoyaltyRead',
  MerchantObjectSettingsLoyaltyCreate: 'MerchantObjectSettingsLoyaltyCreate',
  MerchantObjectSettingsLoyaltyUpdate: 'MerchantObjectSettingsLoyaltyUpdate',
  MerchantObjectSettingsLoyaltyExport: 'MerchantObjectSettingsLoyaltyExport',
  MerchantReportChangeGiftTotalRead: 'MerchantReportChangeGiftTotalRead',
  MerchantReportChangeGiftTotalExport: 'MerchantReportChangeGiftTotalExport',
  MerchantReportChangeGiftRead: 'MerchantReportChangeGiftRead',
  MerchantReportChangeGiftExport: 'MerchantReportChangeGiftExport',
  MerchantReportSumGiftCustomerRead: 'MerchantReportSumGiftCustomerRead',
  MerchantReportSumGiftCustomerExport: 'MerchantReportSumGiftCustomerExport',
  MerchantReportGiftCustomerRead: 'MerchantReportGiftCustomerRead',
  MerchantReportGiftCustomerExport: 'MerchantReportGiftCustomerExport',
  MerchantReportInputOutputRead: 'MerchantReportInputOutputRead',
  MerchantReportInputOutputCreate: 'MerchantReportInputOutputCreate',
  MerchantReportInputOutputUpdate: 'MerchantReportInputOutputUpdate',
  MerchantReportInputOutputDelete: 'MerchantReportInputOutputDelete',
  MerchantReportInputOutputExport: 'MerchantReportInputOutputExport',
  MerchantReportInputOutputImport: 'MerchantReportInputOutputImport',
  MerchantReportStorageCardDetailRead: 'MerchantReportStorageCardDetailRead',
  MerchantReportStorageCardDetailExport: 'MerchantReportStorageCardDetailExport',
  MerchantReportCardRecallRead: 'MerchantReportCardRecallRead',
  MerchantReportCardRecallExport: 'MerchantReportCardRecallExport',
  MerchantReportCardRecallDetailRead: 'MerchantReportCardRecallDetailRead',
  MerchantReportCardRecallDetailExport: 'MerchantReportCardRecallDetailExport',
  MerchantReportGiftForSaleManRead: 'MerchantReportGiftForSaleManRead',
  MerchantReportGiftForSaleManExport: 'MerchantReportGiftForSaleManExport',
  MerchantReportGiftForSaleManDetailRead: 'MerchantReportGiftForSaleManDetailRead',
  MerchantReportGiftForSaleManDetailExport: 'MerchantReportGiftForSaleManDetailExport',
  MerchantMotulScanQRCodeTransactionRead: 'MerchantMotulScanQRCodeTransactionRead',
  MerchantMotulScanQRCodeTransactionExport: 'MerchantMotulScanQRCodeTransactionExport',
  MerchantMotulRedeemTransactionRead: 'MerchantMotulRedeemTransactionRead',
  MerchantMotulRedeemTransactionExport: 'MerchantMotulRedeemTransactionExport',
  MerchantMotulMonthlyPaymentRead: 'MerchantMotulMonthlyPaymentRead',
  MerchantMotulPromotionDetailRead: 'MerchantMotulPromotionDetailRead',
  MerchantMotulPromotionDetailExport: 'MerchantMotulPromotionDetailExport',
  MerchantMotulScanQRCodeAccumulateTransactionRead: 'MerchantMotulScanQRCodeAccumulateTransactionRead',
  MerchantMotulScanQRCodeAccumulateTransactionExport: 'MerchantMotulScanQRCodeAccumulateTransactionExport',
  MerchantMotulScanQRCodeEncroachmentTransactionRead: 'MerchantMotulScanQRCodeEncroachmentTransactionRead',
  MerchantMotulScanQRCodeEncroachmentTransactionExport: 'MerchantMotulScanQRCodeEncroachmentTransactionExport',
  MerchantMotulBenefitQRCodeTransactionRead: 'MerchantMotulBenefitQRCodeTransactionRead',
  MerchantMotulBenefitQRCodeTransactionExport: 'MerchantMotulBenefitQRCodeTransactionExport',
  MerchantMotulUserInfoScanLimitRead: 'MerchantMotulUserInfoScanLimitRead',
  MerchantMotulUserInfoScanLimitUpdate: 'MerchantMotulUserInfoScanLimitUpdate',
  MerchantMotulUserInfoScanLimitImport: 'MerchantMotulUserInfoScanLimitImport',
  MerchantMotulGiftRedemptionConfirmationRead: 'MerchantMotulGiftRedemptionConfirmationRead',
  MerchantMotulGiftRedemptionConfirmationExport: 'MerchantMotulGiftRedemptionConfirmationExport',
  MerchantIDPStoreJoinGameRead: 'MerchantIDPStoreJoinGameRead',
  MerchantIDPStoreJoinGameImport: 'MerchantIDPStoreJoinGameImport',
  MerchantIDPStoreJoinGameExport: 'MerchantIDPStoreJoinGameExport',
  MerchantIDPTurnOfPlayManagementRead: 'MerchantIDPTurnOfPlayManagementRead',
  MerchantIDPTurnOfPlayManagementImport: 'MerchantIDPTurnOfPlayManagementImport',
  MerchantIDPTurnOfPlayManagementExport: 'MerchantIDPTurnOfPlayManagementExport',
  MerchantIDPApprovalChangePhoneNumberRead: 'MerchantIDPApprovalChangePhoneNumberRead',
  MerchantIDPApprovalChangePhoneNumberApproval: 'MerchantIDPApprovalChangePhoneNumberApproval',
  MerchantIDPApprovalChangePhoneNumberDelete: 'MerchantIDPApprovalChangePhoneNumberDelete',
  MerchantMotulPromotionRead: 'MerchantMotulPromotionRead',
  MerchantMotulPromotionCreate: 'MerchantMotulPromotionCreate',
  MerchantMotulPromotionUpdate: 'MerchantMotulPromotionUpdate',
  MerchantMotulPromotionDelete: 'MerchantMotulPromotionDelete',
  MerchantMotulBusinessProductRead: 'MerchantMotulBusinessProductRead',
  MerchantMotulBusinessProductCreate: 'MerchantMotulBusinessProductCreate',
  MerchantMotulBusinessProductUpdate: 'MerchantMotulBusinessProductUpdate',
  MerchantMotulBusinessProductDelete: 'MerchantMotulBusinessProductDelete',
  MerchantMotulBusinessProductImport: 'MerchantMotulBusinessProductImport',
  MerchantMotulObjectSettingRead: 'MerchantMotulObjectSettingRead',
  MerchantMotulObjectSettingCreate: 'MerchantMotulObjectSettingCreate',
  MerchantMotulObjectSettingUpdate: 'MerchantMotulObjectSettingUpdate',
  MerchantMotulObjectSettingDelete: 'MerchantMotulObjectSettingDelete',
  MerchantMotulObjectSettingImport: 'MerchantMotulObjectSettingImport',
  MerchantAppMemberRegistrationRead: 'MerchantAppMemberRegistrationRead',
  MerchantAppMemberRegistrationCreate: 'MerchantAppMemberRegistrationCreate',
  MerchantAppScanGiftRead: 'MerchantAppScanGiftRead',
  MerchantAppScanGiftCreate: 'MerchantAppScanGiftCreate',
  MerchantAppInputGiftFromMerchantRead: 'MerchantAppInputGiftFromMerchantRead',
  MerchantAppInputGiftFromMerchantCreate: 'MerchantAppInputGiftFromMerchantCreate',
  MerchantAppListGiftInStorageRead: 'MerchantAppListGiftInStorageRead',
  MerchantAppListGiftInStorageCreate: 'MerchantAppListGiftInStorageCreate',
  MerchantAppGiveGiftToCustomerManagementRead: 'MerchantAppGiveGiftToCustomerManagementRead',
  MerchantAppGiveGiftToCustomerManagementCreate: 'MerchantAppGiveGiftToCustomerManagementCreate',
  MerchantAppSearchCustomerInfoRead: 'MerchantAppSearchCustomerInfoRead',
  MerchantAppSearchCustomerInfoCreate: 'MerchantAppSearchCustomerInfoCreate',
  MerchantAppReportRead: 'MerchantAppReportRead',
  MerchantAppReportReceiveNoti: 'MerchantAppReportReceiveNoti',
  MerchantAppStoreRead: 'MerchantAppStoreRead',
  MerchantAppStoreCreate: 'MerchantAppStoreCreate',
  MerchantAppStoreUpdate: 'MerchantAppStoreUpdate',
  MerchantAppStoreDelete: 'MerchantAppStoreDelete',
  MerchantAppGiftRead: 'MerchantAppGiftRead',
  MerchantAppGiftCreate: 'MerchantAppGiftCreate',
  MerchantAppGiftUpdate: 'MerchantAppGiftUpdate',
  MerchantAppGiftDelete: 'MerchantAppGiftDelete',
  MerchantAppNotificationSettingRead: 'MerchantAppNotificationSettingRead',
  MerchantAppNotificationSettingCreate: 'MerchantAppNotificationSettingCreate',
  MerchantAppNotificationSettingUpdate: 'MerchantAppNotificationSettingUpdate',
  MerchantAppTicketRead: 'MerchantAppTicketRead',
  MerchantAppTicketCreate: 'MerchantAppTicketCreate',
  MerchantAppTicketUpdate: 'MerchantAppTicketUpdate',
  MerchantAppMemberRankDashboardRead: 'MerchantAppMemberRankDashboardRead',
  MerchantAppTransactionRead: 'MerchantAppTransactionRead',
  MerchantAppUserManagementRead: 'MerchantAppUserManagementRead',
  MerchantAppManagementAccountRead: 'MerchantAppManagementAccountRead',
  MerchantAppManagementAccountCreate: 'MerchantAppManagementAccountCreate',
  MerchantAppManagementAccountUpdate: 'MerchantAppManagementAccountUpdate',
  MerchantAppManagementAccountImport: 'MerchantAppManagementAccountImport',
  MerchantAppLoyaltyProgramRead: 'MerchantAppLoyaltyProgramRead',
  MerchantAppLoyaltyProgramCreate: 'MerchantAppLoyaltyProgramCreate',
  MerchantAppLoyaltyProgramUpdate: 'MerchantAppLoyaltyProgramUpdate',
  MerchantAppLoyaltyProgramCancel: 'MerchantAppLoyaltyProgramCancel',
  MerchantAppLoyaltyProgramDelete: 'MerchantAppLoyaltyProgramDelete',
  UserVoucherGiftRead: 'UserVoucherGiftRead',
  UserVoucherGiftCreate: 'UserVoucherGiftCreate',
  UserVoucherGiftUpdate: 'UserVoucherGiftUpdate',
  UserVoucherGiftDelete: 'UserVoucherGiftDelete',
  UserVoucherGiftReview: 'UserVoucherGiftReview',
  MerchantInchargeContent: 'MerchantInchargeContent',
  MerchantInchargeGift: 'MerchantInchargeGift',
  MerchantInchargeContentSettings: 'MerchantInchargeContentSettings',
  MerchantInchargeNotification: 'MerchantInchargeNotification',
  MerchantAutomaticInteractionRead: 'MerchantAutomaticInteractionRead',
  MerchantAutomaticInteractionCreate: 'MerchantAutomaticInteractionCreate',
  MerchantAutomaticInteractionUpdate: 'MerchantAutomaticInteractionUpdate',
  MerchantAutomaticInteractionDelete: 'MerchantAutomaticInteractionDelete',
  MerchantAutomaticInteractionAccountSmsZnsRead: 'MerchantAutomaticInteractionAccountSmsZnsRead',
  MerchantAutomaticInteractionAccountSmsZnsCreate: 'MerchantAutomaticInteractionAccountSmsZnsCreate',
  MerchantAutomaticInteractionAccountSmsZnsUpdate: 'MerchantAutomaticInteractionAccountSmsZnsUpdate',
  MerchantAutomaticInteractionAccountSmsZnsDelete: 'MerchantAutomaticInteractionAccountSmsZnsDelete',
  MerchantPrepaidCardPurchasesManagementRead: 'MerchantPrepaidCardPurchasesManagementRead',
  MerchantPrepaidCardPurchasesManagementApprove: 'MerchantPrepaidCardPurchasesManagementApprove',
  MerchantDataJourneyMapRead: 'MerchantDataJourneyMapRead',
  MerchantDataJourneyMapCreate: 'MerchantDataJourneyMapCreate',
  MerchantDataJourneyMapUpdate: 'MerchantDataJourneyMapUpdate',
  MerchantDataJourneyMapDelete: 'MerchantDataJourneyMapDelete',
  MerchantDataJourneyMapExport: 'MerchantDataJourneyMapExport',
  MerchantEventDataMetricsRead: 'MerchantEventDataMetricsRead',
  MerchantEventDataMetricsCreate: 'MerchantEventDataMetricsCreate',
  MerchantEventDataMetricsUpdate: 'MerchantEventDataMetricsUpdate',
  MerchantEventDataMetricsDelete: 'MerchantEventDataMetricsDelete',
  MerchantProfileManagementRead: 'MerchantProfileManagementRead',
  MerchantProfileManagementCreate: 'MerchantProfileManagementCreate',
  MerchantProfileManagementUpdate: 'MerchantProfileManagementUpdate',
  MerchantProfileManagementDelete: 'MerchantProfileManagementDelete',
  MerchantProfileManagementExport: 'MerchantProfileManagementExport',
  MerchantProfileManagementImport: 'MerchantProfileManagementImport',
  MerchantSegmentManagementRead: 'MerchantSegmentManagementRead',
  MerchantSegmentManagementCreate: 'MerchantSegmentManagementCreate',
  MerchantSegmentManagementUpdate: 'MerchantSegmentManagementUpdate',
  MerchantSegmentManagementDelete: 'MerchantSegmentManagementDelete',
  MerchantSegmentManagementExport: 'MerchantSegmentManagementExport',
  MerchantDynamicFormRead: 'MerchantDynamicFormRead',
  MerchantDynamicFormCreate: 'MerchantDynamicFormCreate',
  MerchantDynamicFormUpdate: 'MerchantDynamicFormUpdate',
  MerchantDynamicFormDelete: 'MerchantDynamicFormDelete',
  MerchantDigitalDataAssetsRead: 'MerchantDigitalDataAssetsRead',
  MerchantDigitalDataAssetsCreate: 'MerchantDigitalDataAssetsCreate',
  MerchantDigitalDataAssetsUpdate: 'MerchantDigitalDataAssetsUpdate',
  MerchantDigitalDataAssetsDelete: 'MerchantDigitalDataAssetsDelete',
  MerchantSystemDataSettingsRead: 'MerchantSystemDataSettingsRead',
  MerchantSystemDataSettingsCreate: 'MerchantSystemDataSettingsCreate',
  MerchantSystemDataSettingsUpdate: 'MerchantSystemDataSettingsUpdate',
  MerchantSystemDataSettingsDelete: 'MerchantSystemDataSettingsDelete',
  MerchantStoreGiftWarehouseRead: 'MerchantStoreGiftWarehouseRead',
  MerchantStoreGiftWarehouseCreate: 'MerchantStoreGiftWarehouseCreate',
  MerchantStoreGiftWarehouseUpdate: 'MerchantStoreGiftWarehouseUpdate',
  MerchantStoreGiftWarehouseImport: 'MerchantStoreGiftWarehouseImport',
  MerchantStoreGiftWarehouseExport: 'MerchantStoreGiftWarehouseExport',
  MerchantStoreGiftWarehouseDeltele: 'MerchantStoreGiftWarehouseDeltele',
  MerchantVitaDairyTopupRead: 'MerchantVitaDairyTopupRead',
  MerchantVitaDairyTopupRetry: 'MerchantVitaDairyTopupRetry',
  MerchantVitaDairyTopupExport: 'MerchantVitaDairyTopupExport',
  MerchantVitaDairyTopupDelete: 'MerchantVitaDairyTopupDelete',
  MerchantVitaDairyOggiTopupRead: 'MerchantVitaDairyOggiTopupRead',
  MerchantVitaDairyOggiTopupRetry: 'MerchantVitaDairyOggiTopupRetry',
  MerchantVitaDairyOggiTopupExport: 'MerchantVitaDairyOggiTopupExport',
  MerchantVitaDairyOggiTopupDelete: 'MerchantVitaDairyOggiTopupDelete',
  MerchantVitaDairyQRCodeCampaignRead: 'MerchantVitaDairyQRCodeCampaignRead',
  MerchantVitaDairyQRCodeCampaignCreate: 'MerchantVitaDairyQRCodeCampaignCreate',
  MerchantVitaDairyQRCodeCampaignUpdate: 'MerchantVitaDairyQRCodeCampaignUpdate',
  MerchantVitaDairyQRCodeCampaignDelete: 'MerchantVitaDairyQRCodeCampaignDelete',
  MerchantLoyaltyRewardTypeRead: 'MerchantLoyaltyRewardTypeRead',
  MerchantLoyaltyRewardTypeCreate: 'MerchantLoyaltyRewardTypeCreate',
  MerchantLoyaltyRewardTypeUpdate: 'MerchantLoyaltyRewardTypeUpdate',
  MerchantLoyaltyProgramSetupRead: 'MerchantLoyaltyProgramSetupRead',
  MerchantLoyaltyProgramSetupCreate: 'MerchantLoyaltyProgramSetupCreate',
  MerchantLoyaltyProgramSetupUpdate: 'MerchantLoyaltyProgramSetupUpdate',
  MerchantLoyaltyProgramSetupDelete: 'MerchantLoyaltyProgramSetupDelete',
  MerchantLoyaltyProgramSetupReview: 'MerchantLoyaltyProgramSetupReview',
  MerchantVitaDairyQRCodeRead: 'MerchantVitaDairyQRCodeRead',
  MerchantVitaDairyQRCodeCreate: 'MerchantVitaDairyQRCodeCreate',
  MerchantVitaDairyQRCodeUpdate: 'MerchantVitaDairyQRCodeUpdate',
  MerchantVitaDairyQRCodeDelete: 'MerchantVitaDairyQRCodeDelete',
  MerchantVitaDairyQRCodeImport: 'MerchantVitaDairyQRCodeImport',
  MerchantVitaDairyScanQRCodeAccumulateTransactionRead: 'MerchantVitaDairyScanQRCodeAccumulateTransactionRead',
  MerchantVitaDairyScanQRCodeAccumulateTransactionExport: 'MerchantVitaDairyScanQRCodeAccumulateTransactionExport',
  MerchantVitaDairyOggiScanQRCodeAccumulateTransactionRead: 'MerchantVitaDairyOggiScanQRCodeAccumulateTransactionRead',
  MerchantVitaDairyOggiScanQRCodeAccumulateTransactionExport: 'MerchantVitaDairyOggiScanQRCodeAccumulateTransactionExport',
  MerchantLOFQRCodeCampaignRead: 'MerchantLOFQRCodeCampaignRead',
  MerchantLOFQRCodeCampaignCreate: 'MerchantLOFQRCodeCampaignCreate',
  MerchantLOFQRCodeCampaignUpdate: 'MerchantLOFQRCodeCampaignUpdate',
  MerchantLOFQRCodeCampaignDelete: 'MerchantLOFQRCodeCampaignDelete',
  MerchantLOFQRCodeRead: 'MerchantLOFQRCodeRead',
  MerchantLOFQRCodeCreate: 'MerchantLOFQRCodeCreate',
  MerchantLOFQRCodeUpdate: 'MerchantLOFQRCodeUpdate',
  MerchantLOFQRCodeDelete: 'MerchantLOFQRCodeDelete',
  MerchantLOFQRCodeImport: 'MerchantLOFQRCodeImport',
  MerchantPoolWinnerCheatPerUserConfigRead: 'MerchantPoolWinnerCheatPerUserConfigRead',
  MerchantPoolWinnerCheatPerUserConfigCreate: 'MerchantPoolWinnerCheatPerUserConfigCreate',
  MerchantPoolWinnerCheatPerUserConfigUpdate: 'MerchantPoolWinnerCheatPerUserConfigUpdate',
  MerchantPoolWinnerCheatPerUserConfigApprove: 'MerchantPoolWinnerCheatPerUserConfigApprove',
  MerchantPoolWinnerConfigRead: 'MerchantPoolWinnerConfigRead',
  MerchantPoolWinnerConfigCreate: 'MerchantPoolWinnerConfigCreate',
  MerchantPoolWinnerConfigUpdate: 'MerchantPoolWinnerConfigUpdate',
  MerchantPoolWinnerConfigApprove: 'MerchantPoolWinnerConfigApprove',
  MerchantLOFCashoutRead: 'MerchantLOFCashoutRead',
  MerchantLOFCashoutApprove: 'MerchantLOFCashoutApprove',
  MerchantLOFReferralRead: 'MerchantLOFReferralRead',
  MerchantLOFReferralExport: 'MerchantLOFReferralExport',
  MerchantLOFPointGiftRead: 'MerchantLOFPointGiftRead',
  MerchantLOFPointGiftExport: 'MerchantLOFPointGiftExport',
  MerchantGiftReview: 'MerchantGiftReview',
  MerchantMonopolyGameRead: 'MerchantMonopolyGameRead',
  MerchantMonopolyGameExport: 'MerchantMonopolyGameExport',
  MerchantNuviLiveBattleRead: 'MerchantNuviLiveBattleRead',
  MerchantNuviLiveBattleCreate: 'MerchantNuviLiveBattleCreate',
  MerchantNuviLiveBattleUpdate: 'MerchantNuviLiveBattleUpdate',
  MerchantNuviLiveBattleDelete: 'MerchantNuviLiveBattleDelete',
  MerchantVitaDairyScanQRCodeLimitRead: 'MerchantVitaDairyScanQRCodeLimitRead',
  MerchantVitaDairyScanQRCodeLimitDetailRead: 'MerchantVitaDairyScanQRCodeLimitDetailRead',
  MerchantVitaDairyScanQRCodeLimitExport: 'MerchantVitaDairyScanQRCodeLimitExport',
  MerchantVitaDairyScanQRCodeLimitExportDataRaw: 'MerchantVitaDairyScanQRCodeLimitExportDataRaw',
  MerchantVitaDairyOggiScanQRCodeLimitRead: 'MerchantVitaDairyOggiScanQRCodeLimitRead',
  MerchantVitaDairyOggiScanQRCodeLimitDetailRead: 'MerchantVitaDairyOggiScanQRCodeLimitDetailRead',
  MerchantVitaDairyOggiScanQRCodeLimitExport: 'MerchantVitaDairyOggiScanQRCodeLimitExport',
  MerchantVitaDairyOggiScanQRCodeLimitExportDataRaw: 'MerchantVitaDairyOggiScanQRCodeLimitExportDataRaw',
  MerchantVitaDairyScanQRCodeLimitConfigRead: 'MerchantVitaDairyScanQRCodeLimitConfigRead',
  MerchantVitaDairyScanQRCodeLimitConfigDetailRead: 'MerchantVitaDairyScanQRCodeLimitConfigDetailRead',
  MerchantVitaDairyScanQRCodeLimitConfigCreate: 'MerchantVitaDairyScanQRCodeLimitConfigCreate',
  MerchantVitaDairyScanQRCodeLimitConfigUpdate: 'MerchantVitaDairyScanQRCodeLimitConfigUpdate',
  MerchantVitaDairyScanQRCodeLimitConfigDetele: 'MerchantVitaDairyScanQRCodeLimitConfigDetele',
  MerchantVitaDairyScanQRCodeLimitConfigReadMemberDetail: 'MerchantVitaDairyScanQRCodeLimitConfigReadMemberDetail',
  MerchantQRScanLimitConfigRead: 'MerchantQRScanLimitConfigRead',
  MerchantLuckyDrawBlacklistRead: 'MerchantLuckyDrawBlacklistRead',
  MerchantVitaDairyUseRewardLimitConfigRead: 'MerchantVitaDairyUseRewardLimitConfigRead',
  MerchantVitaDairyUseRewardLimitConfigDetailRead: 'MerchantVitaDairyUseRewardLimitConfigDetailRead',
  MerchantVitaDairyUseRewardLimitConfigCreate: 'MerchantVitaDairyUseRewardLimitConfigCreate',
  MerchantVitaDairyUseRewardLimitConfigUpdate: 'MerchantVitaDairyUseRewardLimitConfigUpdate',
  MerchantVitaDairyUseRewardLimitConfigDelete: 'MerchantVitaDairyUseRewardLimitConfigDelete',
  MerchantVitaDairyOggiScanQRCodeLimitConfigRead: 'MerchantVitaDairyOggiScanQRCodeLimitConfigRead',
  MerchantVitaDairyOggiScanQRCodeLimitConfigDetailRead: 'MerchantVitaDairyOggiScanQRCodeLimitConfigDetailRead',
  MerchantVitaDairyOggiScanQRCodeLimitConfigCreate: 'MerchantVitaDairyOggiScanQRCodeLimitConfigCreate',
  MerchantVitaDairyOggiScanQRCodeLimitConfigUpdate: 'MerchantVitaDairyOggiScanQRCodeLimitConfigUpdate',
  MerchantVitaDairyOggiScanQRCodeLimitConfigDelete: 'MerchantVitaDairyOggiScanQRCodeLimitConfigDelete',
  MerchantVitaDairyOggiScanQRCodeLimitConfigReadMemberDetail: 'MerchantVitaDairyOggiScanQRCodeLimitConfigReadMemberDetail',
  MerchantUserGiftOrderRead: 'MerchantUserGiftOrderRead',
  MerchantUserGiftOrderExport: 'MerchantUserGiftOrderExport',
  MerchantUserGiftOrderExportEMS: 'MerchantUserGiftOrderExportEMS',
  MerchantUserGiftOrderImportEMS: 'MerchantUserGiftOrderImportEMS',
  MerchantUserGiftOrderImportStatus: 'MerchantUserGiftOrderImportStatus',
  MerchantLuckyDrawRewardDetailRead: 'MerchantLuckyDrawRewardDetailRead',
  MerchantLuckyDrawRewardDetailExport: 'MerchantLuckyDrawRewardDetailExport',
  MerchantClimbToTheTopGameHistoryRead: 'MerchantClimbToTheTopGameHistoryRead',
  MerchantClimbToTheTopGameHistoryExport: 'MerchantClimbToTheTopGameHistoryExport',
  MerchantUserGiftClaimIdentityRead: 'MerchantUserGiftClaimIdentityRead',
  MerchantUserGiftClaimIdentityUpdate: 'MerchantUserGiftClaimIdentityUpdate',
  MerchantLotteryRewardDetailRead: 'MerchantLotteryRewardDetailRead',
  MerchantLotteryRewardDetailExport: 'MerchantLotteryRewardDetailExport',
  MerchantLotteryGameRoundRead: 'MerchantLotteryGameRoundRead',
  MerchantLotteryGameRoundDial: 'MerchantLotteryGameRoundDial',
  MerchantLotteryGameRoundDialTest: 'MerchantLotteryGameRoundDialTest',
  MerchantLuckyDrawRewardAllocationConfigRead: 'MerchantLuckyDrawRewardAllocationConfigRead',
  MerchantLuckyDrawRewardAllocationConfigCreate: 'MerchantLuckyDrawRewardAllocationConfigCreate',
  MerchantLuckyDrawRewardAllocationConfigUpdate: 'MerchantLuckyDrawRewardAllocationConfigUpdate',
  MerchantLuckyDrawRewardAllocationConfigDelete: 'MerchantLuckyDrawRewardAllocationConfigDelete',
  MerchantLuckyDrawRewardAllocationConfigWard: 'MerchantLuckyDrawRewardAllocationConfigWard',
  MerchantLuckyDrawGeoZoneConfigRead: 'MerchantLuckyDrawGeoZoneConfigRead',
  MerchantLuckyDrawGeoZoneConfigCreate: 'MerchantLuckyDrawGeoZoneConfigCreate',
  MerchantLuckyDrawGeoZoneConfigUpdate: 'MerchantLuckyDrawGeoZoneConfigUpdate',
  MerchantLuckyDrawGeoZoneConfigDelete: 'MerchantLuckyDrawGeoZoneConfigDelete',
  MerchantFeatureMailConfigRead: 'MerchantFeatureMailConfigRead',
  MerchantFeatureMailConfigCreate: 'MerchantFeatureMailConfigCreate',
  MerchantFeatureMailConfigUpdate: 'MerchantFeatureMailConfigUpdate',
  MerchantFeatureMailConfigDelete: 'MerchantFeatureMailConfigDelete',
  MerchantLiveSessionRead: 'MerchantLiveSessionRead',
  MerchantLiveSessionCreate: 'MerchantLiveSessionCreate',
  MerchantLiveSessionUpdate: 'MerchantLiveSessionUpdate',
  MerchantLiveSessionDelete: 'MerchantLiveSessionDelete',
  MerchantPostRead: 'MerchantPostRead',
  MerchantPostCreate: 'MerchantPostCreate',
  MerchantPostUpdate: 'MerchantPostUpdate',
  MerchantPostApproval: 'MerchantPostApproval',
  MerchantPostDelete: 'MerchantPostDelete',
  MerchantCreatorCampaignRead: 'MerchantCreatorCampaignRead',
  MerchantCreatorCampaignCreate: 'MerchantCreatorCampaignCreate',
  MerchantCreatorCampaignUpdate: 'MerchantCreatorCampaignUpdate',
  MerchantCreatorCampaignApproval: 'MerchantCreatorCampaignApproval',
  MerchantCreatorCampaignDelete: 'MerchantCreatorCampaignDelete',
  MerchantCampaignSubmissionRead: 'MerchantCampaignSubmissionRead',
  MerchantCampaignSubmissionCreate: 'MerchantCampaignSubmissionCreate',
  MerchantCampaignSubmissionUpdate: 'MerchantCampaignSubmissionUpdate',
  MerchantCampaignSubmissionApproval: 'MerchantCampaignSubmissionApproval',
  MerchantCampaignSubmissionDelete: 'MerchantCampaignSubmissionDelete',
  MerchantCreatorSettlementRead: 'MerchantCreatorSettlementRead',
  MerchantCreatorSettlementCreate: 'MerchantCreatorSettlementCreate',
  MerchantCreatorSettlementUpdate: 'MerchantCreatorSettlementUpdate',
  MerchantCreatorSettlementApproval: 'MerchantCreatorSettlementApproval',
  MerchantCreatorSettlementPayment: 'MerchantCreatorSettlementPayment',
  MerchantCreatorSettlementDelete: 'MerchantCreatorSettlementDelete',
  MerchantCreatorUserBankInformationRead: 'MerchantCreatorUserBankInformationRead',
  MerchantCreatorUserBankInformationCreate: 'MerchantCreatorUserBankInformationCreate',
  MerchantCreatorUserBankInformationUpdate: 'MerchantCreatorUserBankInformationUpdate',
  MerchantCreatorUserBankInformationApproval: 'MerchantCreatorUserBankInformationApproval',
  MerchantCreatorUserBankInformationDelete: 'MerchantCreatorUserBankInformationDelete',
  MerchantPuzzleGiftRead: 'MerchantPuzzleGiftRead',
  MerchantPuzzleGiftCreate: 'MerchantPuzzleGiftCreate',
  MerchantPuzzleGiftUpdate: 'MerchantPuzzleGiftUpdate',
  MerchantPuzzleGiftHistory: 'MerchantPuzzleGiftHistory',
  MerchantPuzzleGiftDelete: 'MerchantPuzzleGiftDelete',
  MerchantUserPuzzleGiftTransactionRead: 'MerchantUserPuzzleGiftTransactionRead',
  MerchantPanasonicScanQRCodeAccumulateTransactionRead: 'MerchantPanasonicScanQRCodeAccumulateTransactionRead',
  MerchantPanasonicScanQRCodeAccumulateTransactionExport: 'MerchantPanasonicScanQRCodeAccumulateTransactionExport',
  MerchantPanasonicScanQRCodeLimitConfigRead: 'MerchantPanasonicScanQRCodeLimitConfigRead',
  MerchantPanasonicScanQRCodeLimitConfigDetailRead: 'MerchantPanasonicScanQRCodeLimitConfigDetailRead',
  MerchantPanasonicScanQRCodeLimitConfigCreate: 'MerchantPanasonicScanQRCodeLimitConfigCreate',
  MerchantPanasonicScanQRCodeLimitConfigUpdate: 'MerchantPanasonicScanQRCodeLimitConfigUpdate',
  MerchantPanasonicScanQRCodeLimitConfigDetele: 'MerchantPanasonicScanQRCodeLimitConfigDetele',
  MerchantPanasonicScanQRCodeLimitConfigReadMemberDetail: 'MerchantPanasonicScanQRCodeLimitConfigReadMemberDetail',
  MerchantPanasonicSurveyRead: 'MerchantPanasonicSurveyRead',
  MerchantPanasonicSurveyDetailRead: 'MerchantPanasonicSurveyDetailRead',
  MerchantPanasonicSurveyCreate: 'MerchantPanasonicSurveyCreate',
  MerchantPanasonicSurveyUpdate: 'MerchantPanasonicSurveyUpdate',
  MerchantPanasonicSurveyDetele: 'MerchantPanasonicSurveyDetele',
  MerchantPanasonicVerificationRead: 'MerchantPanasonicVerificationRead',
  MerchantPanasonicVerificationDetailRead: 'MerchantPanasonicVerificationDetailRead',
  MerchantPanasonicVerificationApproval: 'MerchantPanasonicVerificationApproval',
  MerchantPanasonicVerificationReject: 'MerchantPanasonicVerificationReject',
  MerchantPanasonicMemberRead: 'MerchantPanasonicMemberRead',
  MerchantPanasonicMemberDetailRead: 'MerchantPanasonicMemberDetailRead',
  MerchantPanasonicMemberExport: 'MerchantPanasonicMemberExport',
  MerchantPanasonicMemberSync: 'MerchantPanasonicMemberSync',
  MerchantPanasonicReportRegistrationRead: 'MerchantPanasonicReportRegistrationRead',
  MerchantPanasonicReportRegistrationExport: 'MerchantPanasonicReportRegistrationExport',
  MerchantPanasonicReportScanRead: 'MerchantPanasonicReportScanRead',
  MerchantPanasonicReportScanExport: 'MerchantPanasonicReportScanExport',
  MerchantPanasonicReportActivityRead: 'MerchantPanasonicReportActivityRead',
  MerchantPanasonicReportActivityExport: 'MerchantPanasonicReportActivityExport',
  MerchantPanasonicReportMissionRead: 'MerchantPanasonicReportMissionRead',
  MerchantPanasonicReportMissionExport: 'MerchantPanasonicReportMissionExport',
  MerchantPanasonicReportSegmentRead: 'MerchantPanasonicReportSegmentRead',
  MerchantPanasonicReportSegmentExport: 'MerchantPanasonicReportSegmentExport',
  MerchantPanasonicReportAccessTimeRead: 'MerchantPanasonicReportAccessTimeRead',
  MerchantPanasonicReportAccessTimeExport: 'MerchantPanasonicReportAccessTimeExport',
  MerchantPanasonicReportRedeemRead: 'MerchantPanasonicReportRedeemRead',
  MerchantPanasonicReportRedeemExport: 'MerchantPanasonicReportRedeemExport',
  MerchantPanasonicReportSurveyRead: 'MerchantPanasonicReportSurveyRead',
  MerchantPanasonicReportSurveyExport: 'MerchantPanasonicReportSurveyExport',
  MerchantVitaDairySalesmanRead: 'MerchantVitaDairySalesmanRead',
  MerchantVitaDairySalesmanCreate: 'MerchantVitaDairySalesmanCreate',
  MerchantVitaDairySalesmanUpdate: 'MerchantVitaDairySalesmanUpdate',
  MerchantVitaDairySalesmanDetele: 'MerchantVitaDairySalesmanDetele',
  MerchantVitaDairySalesmanImport: 'MerchantVitaDairySalesmanImport',
  MerchantVitaDairyQrScanAllowlistRead: 'MerchantVitaDairyQrScanAllowlistRead',
  MerchantVitaDairyQrScanAllowlistCreate: 'MerchantVitaDairyQrScanAllowlistCreate',
  MerchantVitaDairyQrScanAllowlistUpdate: 'MerchantVitaDairyQrScanAllowlistUpdate',
  MerchantVitaDairyQrScanAllowlistDetele: 'MerchantVitaDairyQrScanAllowlistDetele',
  MerchantVitaDairyQrScanAllowlistImport: 'MerchantVitaDairyQrScanAllowlistImport',
  MerchantVitaDairyOggiSalesmanRead: 'MerchantVitaDairyOggiSalesmanRead',
  MerchantVitaDairyOggiSalesmanCreate: 'MerchantVitaDairyOggiSalesmanCreate',
  MerchantVitaDairyOggiSalesmanUpdate: 'MerchantVitaDairyOggiSalesmanUpdate',
  MerchantVitaDairyOggiSalesmanDelete: 'MerchantVitaDairyOggiSalesmanDelete',
  MerchantVitaDairyOggiSalesmanImport: 'MerchantVitaDairyOggiSalesmanImport',
  MerchantVitaDairyDistributorGiftExchangeRead: 'MerchantVitaDairyDistributorGiftExchangeRead',
  MerchantVitaDairyDistributorGiftExchangeExport: 'MerchantVitaDairyDistributorGiftExchangeExport',
  MerchantVitaDairyOggiDistributorGiftExchangeRead: 'MerchantVitaDairyOggiDistributorGiftExchangeRead',
  MerchantVitaDairyOggiDistributorGiftExchangeExport: 'MerchantVitaDairyOggiDistributorGiftExchangeExport',
  MerchantNuviProductRead: 'MerchantNuviProductRead',
  MerchantNuviProductCreate: 'MerchantNuviProductCreate',
  MerchantNuviProductUpdate: 'MerchantNuviProductUpdate',
  MerchantNuviProductDelete: 'MerchantNuviProductDelete',
  MerchantNuviProductImport: 'MerchantNuviProductImport',
  MerchantNuviScanQRCodeAccumulateTransactionRead: 'MerchantNuviScanQRCodeAccumulateTransactionRead',
  MerchantNuviScanQRCodeAccumulateTransactionExport: 'MerchantNuviScanQRCodeAccumulateTransactionExport',
  CampaignBrandRead: 'CampaignBrandRead',
  CampaignBrandCreate: 'CampaignBrandCreate',
  CampaignBrandUpdate: 'CampaignBrandUpdate',
  CampaignBrandDelete: 'CampaignBrandDelete',
  CampaignRewardRead: 'CampaignRewardRead',
  CampaignRewardCreate: 'CampaignRewardCreate',
  CampaignRewardUpdate: 'CampaignRewardUpdate',
  CampaignRewardDelete: 'CampaignRewardDelete',
  CampaignProductRead: 'CampaignProductRead',
  CampaignProductCreate: 'CampaignProductCreate',
  CampaignProductUpdate: 'CampaignProductUpdate',
  CampaignProductDelete: 'CampaignProductDelete',
  CampaignProductImport: 'CampaignProductImport',
  CampaignProductQrRead: 'CampaignProductQrRead',
  CampaignProductQrCreate: 'CampaignProductQrCreate',
  CampaignProductQrUpdate: 'CampaignProductQrUpdate',
  CampaignProductQrDelete: 'CampaignProductQrDelete',
  CampaignProductQrImport: 'CampaignProductQrImport',
  CampaignProductQrExport: 'CampaignProductQrExport',
  CampaignGiftRead: 'CampaignGiftRead',
  CampaignGiftCreate: 'CampaignGiftCreate',
  CampaignGiftUpdate: 'CampaignGiftUpdate',
  CampaignGiftDelete: 'CampaignGiftDelete',
  CampaignGiftImport: 'CampaignGiftImport',
  CampaignGiftExport: 'CampaignGiftExport',
  CampaignSurveyRead: 'CampaignSurveyRead',
  CampaignSurveyCreate: 'CampaignSurveyCreate',
  CampaignSurveyUpdate: 'CampaignSurveyUpdate',
  CampaignSurveyDelete: 'CampaignSurveyDelete',
  CampaignGameRead: 'CampaignGameRead',
  CampaignGameCreate: 'CampaignGameCreate',
  CampaignGameUpdate: 'CampaignGameUpdate',
  CampaignGameDelete: 'CampaignGameDelete',
  CampaignGameExport: 'CampaignGameExport',
  DpointCampaignCreate: 'DpointCampaignCreate',
  DpointCampaignRead: 'DpointCampaignRead',
  DpointCampaignUpdate: 'DpointCampaignUpdate',
  DpointCampaignDelete: 'DpointCampaignDelete',
  CampaignUserManagementRead: 'CampaignUserManagementRead',
  CampaignUserManagementCreate: 'CampaignUserManagementCreate',
  CampaignUserManagementUpdate: 'CampaignUserManagementUpdate',
  CampaignUserManagementDelete: 'CampaignUserManagementDelete',
  CampaignCustomerGroupRead: 'CampaignCustomerGroupRead',
  CampaignCustomerGroupCreate: 'CampaignCustomerGroupCreate',
  CampaignCustomerGroupUpdate: 'CampaignCustomerGroupUpdate',
  CampaignCustomerGroupDelete: 'CampaignCustomerGroupDelete',
  CampaignAutomationInteractionRead: 'CampaignAutomationInteractionRead',
  CampaignAutomationInteractionCreate: 'CampaignAutomationInteractionCreate',
  CampaignAutomationInteractionWrite: 'CampaignAutomationInteractionWrite',
  CampaignAutomationInteractionDelete: 'CampaignAutomationInteractionDelete',
});

const reportedKeys = new Set();

const reportUnknownKey = (key) => {
  if (typeof key !== 'string' || !/^[A-Z][A-Za-z0-9]*$/.test(key) || key in permissions) return;
  if (reportedKeys.has(key)) return;
  reportedKeys.add(key);
  console.error(`MERCHANT_PERMISSIONS.${key} is not a grantable permission in MerchantPermission.cs`);
};

export const MERCHANT_PERMISSIONS =
  process.env.NODE_ENV === 'production'
    ? permissions
    : new Proxy(permissions, {
        get(target, key) {
          reportUnknownKey(key);
          return target[key];
        },
      });
